// 全局引入element
import 'element-ui/lib/theme-chalk/index.css';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import fly from './utils/http';
import store from './store';
import Toast from './components/Toast';
import vMsg from './components/vMessage';
import vModal from './components/vModal';
import mitt from 'mitt';
import VueCompositionApi from '@vue/composition-api';
import { reportAegisError } from '@/utils/aegis';
// 公共基础样式
import 'assets/less/common.less';
import ElementUI from 'element-ui';
import { Message, loadScript, getDoctorInfo } from '@/utils/utils';
import SyncElButton from './components/syncElButton/syncElButton.vue';
import { HOSPITAL_CONFIG } from './config/hospital';
import { isNetworkEnv } from './utils/utils';
import { preventXss } from '@/utils/secure';
import HealthDeptReqReport from '@tencent/health-dept-req-report';
Vue.prototype.preventXss = preventXss;

Vue.component('SyncElButton', SyncElButton);
Vue.use(ElementUI);
Vue.prototype.$http = fly;
Vue.prototype.$message = Message;
Vue.prototype.$notify = ElementUI.Notification;
Vue.use(VueCompositionApi);
Vue.prototype.$toast = Toast;
Vue.prototype.$vMsg = vMsg;
Vue.prototype.$vModal = vModal;
Vue.prototype.$emitter = mitt();
Vue.prototype.$global = {
  projectName: HOSPITAL_CONFIG.default.projectName,
  miniProjectName: HOSPITAL_CONFIG.default.miniProjectName,
};
Vue.config.productionTip = false;
Vue.config.errorHandler = async (err) => {
  console.log('%c Line:30 🥪 err', 'color:#93c0a4', err);
  const doctorInfo = await getDoctorInfo();
  if (!err.toString().includes('弹窗拦截') && err.toString() !== '[object Object]') {
    reportAegisError({
      type: 'UNHANDLED_ERROR',
      error: err?.stack || err.toString(),
      extra: {
        userId: doctorInfo.userId,
      },
    });
  }
};
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');

window.onunhandledrejection = (event) => {
  if (event.reason && !event.reason.toString().includes('弹窗拦截') && event.reason.toString() !== '[object Object]') {
    reportAegisError({
      type: 'UNHANDLED_PROMISE_ERROR',
      error: `${event.reason}`,
    });
  }
};
if (isNetworkEnv()) {
  loadScript('https://turing.captcha.qcloud.com/TCaptcha.js');
}
if (process.env.VUE_APP_ENV === 'test') {
  loadScript('https://cle-publicnet-resource-1258344699.cos.ap-guangzhou.myqcloud.com/wan/cle-switch.min.js?projectId=9504');
}
if (process.env.VUE_APP_ENV === 'test' && process.env.NODE_ENV !== 'development') {
  // chargeUser 当前负责人id,   bizId 平台对应所属项目字段
  const report = new HealthDeptReqReport({
    chargeUser: 'edendeng',
    bizId: 'patient_records_web',
    standardHost: 'https://test-doctor.tengmed.com',
  });
  report.startMonitor();
}
